import Warning from './Warn';
import LogUtil from './LogUtil';
import CommonUtil from './CommonUtil';
import ReactDOM from 'react-dom';
import OverallSituationModelDiv from '../websocket/OverallSituationModelDiv';
import React from 'react';
import WebSocketManager from '../websocket/WebSocketManager';
var base64js = require('base64-js');
var pako = require('pako');
class AjaxRemoteUtil
{

	static delay = false;
	static tokenNum = 0;
	static _setProcessID = undefined;

	static setRemoteDisable(params)
	{
		
		if(!params.autoLock) 
			return;
		AjaxRemoteUtil.tokenNum++;
		if(AjaxRemoteUtil.tokenNum == 1)
		{
			AjaxRemoteUtil._setProcessID = setTimeout(
				function()
				{
					if(AjaxRemoteUtil._setProcessID)
					{
						if(window.menuItemId && window.formId)
							window.parent.$("body").mLoading({text:params.lockText});
						else
							$('body').mLoading({text:params.lockText});
					}
						

				},500
			);
		}
	}

	static setRemoteEnable(params)
	{
		if(!params.autoUnlock)
			return;
		AjaxRemoteUtil.tokenNum--;
		if(AjaxRemoteUtil.tokenNum<0)
		{
			Warning.show({text:"调用计数错误，如出现不能访问，请刷新浏览器"});
			AjaxRemoteUtil.tokenNum = 0;
		}
		
		
		if(AjaxRemoteUtil.tokenNum==0)
		{	
			clearTimeout(AjaxRemoteUtil._setProcessID);
			AjaxRemoteUtil._setProcessID = undefined;
			AjaxRemoteUtil._delay = false;
			if(document.readyState != "complete")
				return;
			if(window.menuItemId && window.formId)
				window.parent.$("body").mLoading("hide");
			else
				$('body').mLoading("hide");
		}
	}

	static getParsedErrText(errText)
	{
		return errText;
	}

	static ajaxPost(url,data,resultType,sync,sucessHandler,errorHandler,successIngnoreStatus=false,params)
	{
		if(!params.relativeUrl)
		{
			if(window.urlBase)
				url = urlBase+url;
		}
		
		//url+=("?t="+new Date().getTime())
		//params.autoLock = params.autoUnlock = false;
		//window.temp222 = JSON.parse(data.request);
		//if(window.formModuleInstanceuuId)
		//	window.parent.window.closeForm(window.formModuleInstanceuuId);
		let _headers = {};
		if(params.domain && !params.loginToken && !params.loginDataArea)
		{
			let _token = localStorage.getItem("userToken");
			if(_token)
				_headers.token = _token;
		}
		AjaxRemoteUtil.setRemoteDisable(params);
		return $.ajax({
	        type:'post',
	        url:url,
	        dataType:resultType,
	        data:data,
	        async:!sync,
			headers: _headers,
	        //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
	        xhrFields:{withCredentials:true},
	        //for fireFox
	        /*beforeSend: function(xhr) {
		      xhr.withCredentials = true;
		    },*/
			success:function(data){
				//if(window.temp222.methodName != "reInitForm")
				//if(!window.reInitFormCalled)
				AjaxRemoteUtil.setRemoteEnable(params);
				//console.log(data);

				if(params.logArg)
				{
					params.logArg.duration = (new Date().getTime() - params.logArg.startDateTime)+"";
					params.logArg.startDateTime = params.logArg.startDateTime+"";
					try {
						if(typeof(window.setRpcLog) == "function")
						{
							//status 200
							window.setRpcLog(params.logArg);
						}
						else if(typeof(window.parent.window.setRpcLog) == "function")
						{
							window.parent.window.setRpcLog(params.logArg);
						}
					} catch (error) {
						
					}
				}

				if(data.status == 2)
				{
					var _parentWindow = (window.didomain)?window:window.parent.window;
					if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea){
							if(typeof(window.layui.request.loginOut()) == 'function'){
							   _parentWindow =window;
							}else if(typeof(window.parent.window.layui.request.loginOut()) == 'function'){
							   _parentWindow =window.parent.window;
							}else{
							   _parentWindow =window.parent.parent.window;
							}
							_parentWindow.layui.request.loginOut();
							let UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
							_parentWindow.localStorage.removeItem("username");
							_parentWindow.localStorage.removeItem("userId");
							_parentWindow.localStorage.removeItem("permission");
							_parentWindow.localStorage.removeItem("userToken");
							_parentWindow.localStorage.removeItem(UserId_desktopData);
					}else{
						if(window.parent && window.parent.window){
							window.parent.window.location.href=window.parent.window.loginPath;
						}
						else{

							window.location.href = loginPath;
						}
						}
				}else if(data.status == 3)
				{
					if(data.msg && data.msg.indexOf)
					{

							document.getElementById('overallSituationDiv').style = "width: 100%;height: 100%;position: absolute;top: 0;left: 0;z-index: 9999";
							ReactDOM.render(<OverallSituationModelDiv />, document.getElementById('overallSituationDiv'));
							return
						
					}
				}
				else if(data.status != 0)
				{
					let errText = data.msg;
					if(errText && errText.indexOf("Invoke failed:") == 0)
						errText = errText.substr(15);
					errText = AjaxRemoteUtil.getParsedErrText(errText);
					if(!errorHandler)
						Warning.show({text:errText});
					else
						errorHandler({successButNot0:true,errText:errText});
					if(successIngnoreStatus)
					{
						sucessHandler(data);
					}
				}
				else
				{
					if(data.compress)
					{
						var compressedByteArray = base64js.toByteArray(data.result);
					    var s = pako.inflate(compressedByteArray,{ to: 'string' });  
					    data.result = JSON.parse(s);
					}

					if(data.msg && data.msg.indexOf)
					{
						if(data.msg.indexOf("system maintenance") != -1)
						{
							//TODO 弹出系统正在升级的框并return
						}
					}
					sucessHandler(data);
				}
			},
			error:function(data){
				AjaxRemoteUtil.setRemoteEnable(params);
				//Warning.show({text:"程序遇到了无法处理的问题,请检查网络是否正常或联系管理员解决"});
				if(params.logArg)
				{
					let nowDate = new Date();
					let _duration = (nowDate.getTime() - params.logArg.startDateTime)+"";
					params.logArg.duration = _duration;
					params.logArg.startDateTime = params.logArg.startDateTime+"";
					//params.logArg.duration2 = _duration/1000+"";
					//params.logArg.startDateTime = params.logArg.startDateTime+"";

					params.logArg.readyState = data.readyState+"";
					params.logArg.httpStatus = data.status+"";
					params.logArg.statusText = data.statusText+"";
					params.logArg.state = typeof(data.state) == "function"?data.state()+"":"";
					params.logArg.endDateTime = nowDate.getTime()+"";

					try {
						
						window.parent.window.addClientLogNetWorkErrorData({id:params.logArg.requestId,data:params.logArg});
	
						if(typeof(window.setRpcLog) == "function")
						{
							//httpstatus 不是200
							window.setRpcLog(params.logArg);
						}
						else if(typeof(window.parent.window.setRpcLog) == "function")
						{
							window.parent.window.setRpcLog(params.logArg);
						}
					} catch (error) {
						
					}
				}
				
				if(errorHandler != undefined)
				{
					errorHandler(data);
				}
				else
				{
					//根据data统一处理 应该可以获取到相关异常信息
					Warning.show({text:"网络链接出问题了喔,请稍后再试"});
				}
			}
		});

		/*var xmlhttp = new XMLHttpRequest();
		xmlhttp.withCredentials = true;
		
		xmlhttp.open("POST", url,false);
		//var oMyForm = new FormData();
		//oMyForm.append("request",data.request);
		xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		xmlhttp.send("request="+data.request);
		var result = xmlhttp.responseText;
		var obj = JSON.parse(result);
		AjaxRemoteUtil.ajaxSuccess(obj);*/
		
	}

	static ajaxPost2(url,data,resultType,sync,sucessHandler,errorHandler,successIngnoreStatus=false,params)
	{
		if(!params.relativeUrl)
		{
			if(window.urlBase)
				url = urlBase+url;
		}
		let _headers = {};
		if(params.domain && !params.loginToken && !params.loginDataArea)
		{
			let _token = localStorage.getItem("userToken");
			if(_token)
				_headers.token = _token;
		}
		AjaxRemoteUtil.setRemoteDisable(params);
		return $.ajax({
	        type:'post',
	        url:url,
	        dataType:resultType,
	        data:data,
	        async:!sync,
			headers: _headers,
	        xhrFields:{withCredentials:true},
			success:function(data){
				AjaxRemoteUtil.setRemoteEnable(params);
					if(data.compress)
					{
						var compressedByteArray = base64js.toByteArray(data.result);
					    var s = pako.inflate(compressedByteArray,{ to: 'string' });  
					    data.result = JSON.parse(s);
					}
					
					sucessHandler(data,params.domain,params.shortName);
			},
			error:function(data){
				AjaxRemoteUtil.setRemoteEnable(params);
				if(errorHandler != undefined)
				{
					errorHandler(data);
				}
				else
				{
					// Warning.show({text:"网络链接出问题了喔,请稍后再试"});
				}
			}
		});
		
	}

	static ajaxSuccess(data)
	{
		$("#loading").css('display','none');//console.log(data);
		if(data.status == 2)
		{
			var _parentWindow = (window.didomain)?window:window.parent.window;
			if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea){
					if(typeof(window.layui.request.loginOut()) == 'function'){
					   _parentWindow =window;
					}else if(typeof(window.parent.window.layui.request.loginOut()) == 'function'){
					   _parentWindow =window.parent.window;
					}else{
					   _parentWindow =window.parent.parent.window;
					}
					_parentWindow.layui.request.loginOut();
					let UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
					_parentWindow.localStorage.removeItem("username");
					_parentWindow.localStorage.removeItem("userId");
					_parentWindow.localStorage.removeItem("permission");
					_parentWindow.localStorage.removeItem("userToken");
					_parentWindow.localStorage.removeItem(UserId_desktopData);
			}else{
				if(window.parent && window.parent.window){
					window.parent.window.location.href=window.parent.window.loginPath;
				}
				else{
					window.location.href = loginPath;
				}
			}
		}
		else if(data.status == 1)
		{
			
		}
		else if(data.status != 0)
		{
			alert(data.msg);
		}
		else
		{
			sucessHandler(data);
		}
	}

	static ajaxSend(url,data,resultType,sync,sucessHandler,errorHandler)
	{
		var defer = $.Deferred();
		$.ajax({
	        type:'post',
	        url:url,
	        dataType:resultType,
	        data:data,
	        async:sync,
	        //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
	        xhrFields:{withCredentials:true},
	        success:function(data)
	        {
	        	defer.resolve(data);
	        }
	    });
	    return defer.promise();
	}

	static ajax(type,url,resultType,sync,sucessHandler,errorHandler)
	{
		if(window.urlBase)
			url = urlBase+url;
		$("#loading").css('display','block');
		//alert(url);
		$.ajax({
	        type:type,
	        url:url,
	        dataType:resultType,
	        async:!sync,
	        //暂时在跨域请求时强制浏览器携带cookie
	        xhrFields:{withCredentials:true},
			success:function(data){
				$("#loading").css('display','none');
				if(data.status == 2)
				{
					var _parentWindow = (window.didomain)?window:window.parent.window;
					if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea){
							if(typeof(window.layui.request.loginOut()) == 'function'){
							   _parentWindow =window;
							}else if(typeof(window.parent.window.layui.request.loginOut()) == 'function'){
							   _parentWindow =window.parent.window;
							}else{
							   _parentWindow =window.parent.parent.window;
							}
							_parentWindow.layui.request.loginOut();
							let UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
							_parentWindow.localStorage.removeItem("username");
							_parentWindow.localStorage.removeItem("userId");
							_parentWindow.localStorage.removeItem("permission");
							_parentWindow.localStorage.removeItem("userToken");
							_parentWindow.localStorage.removeItem(UserId_desktopData);
					}else{
						// window.location.href=window.loginPath;
					}
				}
				else
				{
					sucessHandler(data);
				}
			},
			error:function(data){
				$("#loading").css('display','none');
				alert(JSON.stringify(data));
				if(errorHandler != undefined)
				{
					errorHandler(data)
				}
				else
				{
					//根据data统一处理 应该可以获取到相关异常信息
				}
			}
		});
	}
}

export default AjaxRemoteUtil;




// WEBPACK FOOTER //
// ./src/utils/AjaxRemoteUtil.js